module.exports = __webpack_public_path__ + "static/media/story-26.a81ea26e.png";